import api from '../library/axios';

export default {
  getNotificationNews(workspace_id, open_date) {
    return api({
      method: 'get',
      url: `/api/notif/blogs/${workspace_id}/notification-news`,
      params: {
        open_date,
      },
    });
  },
  getNotificationNewsList(workspace_id, query) {
    return api({
      method: 'get',
      url: `/api/notif/blogs/${workspace_id}/notification-news-list`,
      params: query,
    });
  },
  getDetail(blog_id) {
    return api({
      method: 'get',
      url: `/api/notif/blogs/${blog_id}/detail`,
    });
  },
};
